import React from "react";
import NotificationsDrawer, { NotificationCategoryTab } from "../../notifications/NotificationsDrawer";
import { Notification } from "components/common/NotificationTypes";

// NotificationsPreview.tsx

interface Props {
  notifications?: Notification[];
  showCount?: number;
  loading?: boolean;
  setOpen?: () => void;
  onReadAll?: () => void;
  onViewAll?: () => void;
  onRead?: (id: number) => void;
}

const NotificationsPreview: React.FC<Props> = ({
  showCount = 5,
  onViewAll,
  setOpen,
}) => {
  return (
    <NotificationsDrawer
      isOpen={true}
      onClose={setOpen}
      showCount={showCount}
      onViewAll={onViewAll}
    />
  );
};

export default NotificationsPreview;
